var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavingsProd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.3164C0 9.27071 8.95431 0.316406 20 0.316406C31.0457 0.316406 40 9.27071 40 20.3164C40 31.3621 31.0457 40.3164 20 40.3164C8.95431 40.3164 0 31.3621 0 20.3164Z",
    fill: "url(#paint0_linear_9361_42143)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.1406C12 14.1964 12.7832 13.459 13.7143 13.459H23.4286C24.3597 13.459 25.1429 14.1964 25.1429 15.1406V22.6345C25.1429 23.5787 24.3597 24.3161 23.4286 24.3161H13.7143C12.7832 24.3161 12 23.5787 12 22.6345V15.1406ZM14.8857 18.0304C14.4123 18.0304 14.0285 18.4142 14.0285 18.8876C14.0285 19.3609 14.4122 19.7447 14.8856 19.7447C15.359 19.7447 15.7428 19.3609 15.7428 18.8876C15.7428 18.4142 15.359 18.0304 14.8857 18.0304ZM22.2573 18.0304C21.7839 18.0304 21.4001 18.4142 21.4001 18.8876C21.4001 19.3609 21.7839 19.7447 22.2573 19.7447C22.7307 19.7447 23.1144 19.3609 23.1144 18.8876C23.1144 18.4142 22.7307 18.0304 22.2573 18.0304ZM16.8571 18.8876C16.8571 17.9408 17.6247 17.1733 18.5714 17.1733C19.5182 17.1733 20.2857 17.9408 20.2857 18.8876C20.2857 19.8343 19.5182 20.6018 18.5714 20.6018C17.6247 20.6018 16.8571 19.8343 16.8571 18.8876ZM28 18.3161C28 17.8427 27.6162 17.459 27.1429 17.459C26.6695 17.459 26.2857 17.8427 26.2857 18.3161V25.1733C26.2857 25.249 26.2557 25.3217 26.2021 25.3753C26.1485 25.4289 26.0758 25.459 26 25.459H16.2857C15.8123 25.459 15.4286 25.8428 15.4286 26.3161C15.4286 26.7895 15.8123 27.1733 16.2857 27.1733H26C26.5304 27.1733 27.0391 26.9625 27.4142 26.5874C27.7893 26.2124 28 25.7037 28 25.1733V18.3161Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9361_42143",
    x1: 29.7222,
    y1: 4.76085,
    x2: 4.16667,
    y2: 68.0942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9747FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingsProd);
export default __webpack_public_path__ + "static/media/savingsProd.9398498f42c5846ad64138512b11ae6d.svg";
export { ForwardRef as ReactComponent };